import { render, staticRenderFns } from "./BulletFrame.vue?vue&type=template&id=623b2531&scoped=true&"
import script from "./BulletFrame.vue?vue&type=script&lang=js&"
export * from "./BulletFrame.vue?vue&type=script&lang=js&"
import style0 from "./BulletFrame.vue?vue&type=style&index=0&id=623b2531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b2531",
  null
  
)

export default component.exports